import { render } from "./PageTemplateTab.vue?vue&type=template&id=e3584bc4"
import script from "./PageTemplateTab.vue?vue&type=script&lang=js"
export * from "./PageTemplateTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__